import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AvatarImg from 'shared/components/AvatarImg';

const SearchPersons = ({ items, showAllTabs, onClickSeeMore }) => {
  const [showAll, setShowAll] = useState(!showAllTabs);
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    setShowAll(!showAllTabs);
  }, [showAllTabs]);

  const onPersonClick = user => {
    history.push(`/user/${user.id}`);
  };

  if (!items?.length) {
    if (!showAllTabs) {
      return <p className='text-center'>{t('profiles_no_result')}</p>;
    } else {
      return null;
    }
  }

  return (
    <div className='mb-20'>
      <h2 className='mb-2 d-flex align-items-center justify-content-between'>
        {t('title_profiles')}
        {showAllTabs && items?.length > 7 && (
          <button className='btn text-underline p-0 text-primary' onClick={onClickSeeMore}>
            {t('text_see_all')}
          </button>
        )}
      </h2>
      <div className={`d-flex row px-4 px-md-0 ${showAll ? 'flex-wrap' : 'flex-nowrap'}`}>
        {items?.map((user, i) => {
          if (!showAll && i > 6) return null;
          return (
            <div
              className='profile-block p-6 bg-gray-light mx-2 mx-md-8 my-8 rounded-4 pointer'
              tabIndex={-1}
              role='button'
              key={i}
              onClick={onPersonClick.bind(null, user)}
            >
              <div className='mb-5 text-center px-7'>
                <AvatarImg
                  size='lg'
                  width='100px'
                  height='100px'
                  className='m-auto'
                  picture={user.picture}
                  name={user.name}
                />
              </div>
              <p className='mb-0 text-center text-nowrap text-ellipsis'>{user.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SearchPersons;
